export default __webpack_public_path__ + "static/media/home-icon-active.6be77071.webp";